import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';

import { AuthComponent } from './auth.component';
import it from './auth.it.json';

@NgModule({
  imports: [
    CommonModule,
    TranslocoModule,
    ReactiveFormsModule,
    RouterModule.forChild([{path: '', component: AuthComponent}]),

    MatCardModule,
    MatButtonModule,
    MatInputModule,
  ],
  declarations: [AuthComponent],

})
export class AuthModule {
  constructor(private translocoSvc: TranslocoService) {
    this.translocoSvc.setTranslation(it, 'it');
  }
}
